import { createGetEndpoint } from '@sonar-software/sonar-http';

export type AiAgentsResponse = {
	connections: Array<Connection>
};

type Connection = {
	id: number,
	clientName: string,
	createdAt: string,
	lastUsedAt: string,
	refreshExpirationAt: string
};

export const getAiAgents = createGetEndpoint<void, AiAgentsResponse>(
	'/api/mcp/auth/connections'
);
